<div class="irembogov-template-configuration-stepper d-flex flex-column">
  <!-- Stepper Navigation -->
  <div class="configure-stepper-nav-items">
    <div
      class="config-navs d-flex justify-content-center align-items-center border-bottom pb-0 border-2">
      <button
        *ngFor="let step of configSteps; let index = index"
        [class]="{
          selected: index === selectedIndex,
          linkitem: true,
          completed: step.isComplete
        }"
        (click)="selectStepByIndex(index)">
        <i
          class="fa-solid fa-check text-success me-2"
          *ngIf="step.isComplete"></i>
        <i
          aria-hidden="true"
          [class]="
            configSteps[index].icon ? configSteps[index].icon + ' me-2' : 'me-2'
          "
          *ngIf="!step.isComplete"></i>
        <span>
          <span *ngIf="showIndexInLabel">{{ index + 1 }}.&nbsp;</span
          >{{ step.label }}
        </span>
      </button>
    </div>
  </div>

  <!-- Stepper Content -->
  <div class="configure-stepper-content">
    <ng-container [ngTemplateOutlet]="selected ? selected.content : null">
    </ng-container>
  </div>
</div>
